/**
 * Help icon + tooltip — card explainer copy lives here instead of a
 * paragraph under every card title (field feedback 2026-07-03: the
 * descriptive text ate card height and left uneven grids; a ? icon
 * saves the space and keeps the help one hover away).
 */

import React from 'react';
import { HelpCircle } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

export const HelpTip: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="Help"
          className={cn(
            'inline-flex shrink-0 text-fg-muted transition-colors hover:text-fg',
            className,
          )}
        >
          <HelpCircle className="size-3.5" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="max-w-[300px] text-xs leading-snug">
        {children}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default HelpTip;
